export const TIME_TO_OPEN = 240
export const URL_PRODUCTS_PAGE = '/explore/catalogs?catalogId='
